<!-- eslint-disable -->
<template lang="pug">
    .login-box
        .profile(v-if="user")
            .profile__item
                img.avatar(:src="user.avatar")
            .profile__item
                | {{ userGreeting }}
            .profile__item.profile__item--small-padding
                svg-icon.icon(name="university", size="large")
                | {{ user.school.name }}
            hr.login-box__divider
            div.profile__item
                | {{ $i18n.t('dashboard.dashboard_selectCourse_selectYourCourse') }}
            .buttons-container
                .button-container(v-for="course in user.pointsAccesses")
                    cs-button(
                        color="white"
                        :fullWidth="true"
                        @click="selectCourse(course)"
                    ) {{ $i18n.t('common.common_course_' + course) }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import AppHeader from '../../elements/AppHeader.vue'

    export default {
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            userGreeting() {
                return this.$i18n.t('dashboard.dashboard_user_greeting', {name: this.user.firstName});
            }
        },
        methods: {
            logOut() {
                this.$router.push({name: 'dashboard'})
                this.$store.dispatch('logOut')
            },
            selectCourse(course) {
                this.$store.dispatch('setCourse', course);
                this.$router.push({name: 'dashboard'});
            }
        },
        components: {
            AppHeader
        }
    }
</script>

<style lang="scss" scoped>
    .login-box {
        margin: 0 auto;
        background-color: $x-color-white;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 20px;
        @include media($sm) {
            padding: 40px;
            border-radius: 40px;
        }
        @include media($lg) {
            padding: 92px;
        }
    }

    .profile {
        margin: 0 auto;
        padding: 0 30px;
        background-color: var(--user-main-color);
        text-align: center;
        border-radius: 40px;

        font-weight: 500;
        font-size: 22px;
        line-height: 26px;

        color: #FFFFFF;

        max-width: 300px;
        @include media($md) {
            max-width: 600px;
        }
    }

    .profile__item {
        padding-top: 10px;
        @include media($xl) {
            padding-top: 30px;
        }
    }

    .profile__item--small-padding {
        padding-top: 5px;
        @include media($xl) {
            padding-top: 15px;
        }
    }

    .button-container {
        padding-top: 10px;
        @include media($xl) {
            padding-top: 20px;
        }
    }

    .login-box__divider {
        border: 0;
        margin: 15px 0 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        @include media($xl) {
            margin: 30px 0 0;
        }
    }

    .buttons-container {
        max-width: 260px;
        margin: 0 auto;

        &:last-child {
            padding-bottom: 35px;
        }
    }

    .icon {
        margin-right: 5px;
    }

    .avatar {
        border-radius: 50%;
        max-height: none;
        height: 140px;
        width: 140px;
        border: 10px solid rgba($hsl-color-gray-100, 0.2);
    }
</style>
